export const ACTIONS = {
  UPDATE_EVENT_STATUS: 'UPDATE_EVENT_STATUS',
};

export const trackEvent = data => dispatch => {
  dispatch({
    type: ACTIONS.UPDATE_EVENT_STATUS,
    payload: data,
  });
};
